import { KEY } from 'store/booking/types';
import { initBookingRequestStateSelector } from 'store/booking/appointment/initBookingInformation/selectors';

export const INIT_BOOKING_INFORMATION = `${KEY}.INIT_BOOKING_INFORMATION`;

// Fire and forget action. Initializes setting up bookingInformation cache on backed
export const initBookingInformation = (useRequestState = true) => ({
  type: INIT_BOOKING_INFORMATION,
  payload: {
    useRequestState,
    requestStateSelector: initBookingRequestStateSelector,
    client: 'scheduling',
    request: {
      url: `/initBookingInformation`
    }
  }
});
